import * as Yup from 'yup';

const addLeadsSchema = Yup.object().shape({
    name: Yup.string()
        .matches(/^[A-Za-z ]*$/, 'Nama hanya boleh berisi huruf dan spasi')
        .trim('Tidak dapat mengisi hanya dengan spasi')
        .required('Nama Lengkap harus diisi.')
        .max(60, 'Nama tidak boleh lebih dari 60 karakter.'),
    phone: Yup.string()
        .required('Nomor Telepon harus diisi.')
        .min(11, 'Nomor Telepon minimal 9 digit.')
        .matches(
            /^62\d{8,16}$/,
            'Silakan masukan nomor telepon yang valid'
        ),
    email: Yup.string()
        .email('Masukkan alamat email yang valid.')
        .max(234, 'Email tidak boleh lebih dari 234 karakter.'),
    gender: Yup.string()
        .required('Jenis Kelamin harus diisi.'),
    city: Yup.string()
        .trim('Tidak dapat mengisi hanya dengan spasi')
        .required('Kota harus diisi.'),
    needId: Yup.number()
        .typeError('Kebutuhan harus diisi')
        .required('Kebutuhan harus diisi'),
});

export default addLeadsSchema;